import { IsoDate, IsoDateTime, IsoDateTimeTz, IsoDuration } from '../../types/iso-date';
import { assertDatesForComparision } from '../helper/assert-dates-for-comparision.function';

export function sortDates<T extends IsoDate | IsoDateTime | IsoDateTimeTz>(dates: T[], direction: 'asc' | 'desc' = 'asc'): T[] {
  assertDatesForComparision(...dates)
  return dates.map(o => ({parsed: Date.parse(o), original: o}))
    .sort((a, b) => direction === 'asc' ? (a.parsed - b.parsed) : (b.parsed - a.parsed))
    .map(o => o.original);
}
